// Page translators (Google Translate) swap React's text nodes for <font>,
// so skip DOM operations on nodes that were moved instead of crashing.
const { removeChild, insertBefore } = Node.prototype;

Node.prototype.removeChild = function <T extends Node>(child: T) {
  if (child.parentNode !== this) {
    return child;
  }

  return removeChild.call(this, child) as T;
};

Node.prototype.insertBefore = function <T extends Node>(
  node: T,
  referenceNode: Node | null,
) {
  if (referenceNode && referenceNode.parentNode !== this) {
    return node;
  }

  return insertBefore.call(this, node, referenceNode) as T;
};
